import SecondaryPhysician from './SecondaryPhysician';

export default SecondaryPhysician;
